<template>
  <div class="configuration">
    <div class="config-wrap">
      <v-card class="config-card" elevation="0">
        <!-- Médaillon d'icône -->
        <div class="config-badge">
          <v-icon size="34" color="white">mdi-cog</v-icon>
        </div>

        <h2 class="config-title">Configuration</h2>
        <div class="config-subtitle">
          Saisis ton token / ta clé puis valide.
        </div>

        <v-text-field
          v-model="token"
          class="config-field"
          label="Token / Clé"
          variant="outlined"
          density="comfortable"
          rounded="lg"
          prepend-inner-icon="mdi-key-variant"
          :disabled="isLoading"
          @keyup.enter="validate"
        ></v-text-field>

        <v-btn
          class="config-btn"
          block
          size="large"
          rounded="lg"
          :loading="isLoading"
          @click="validate"
        >
          <v-icon start>mdi-check-circle-outline</v-icon>
          Valider
        </v-btn>

        <div class="config-hint">
          <v-icon size="14" class="mr-1">mdi-shield-key-outline</v-icon>
          Ta clé est envoyée de façon sécurisée.
        </div>
      </v-card>
    </div>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top">
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import homePageData from "../hooks/page-home";

export default {
  setup() {
    const { token, isLoading, snackbar, validate } = homePageData();

    return {
      token,
      isLoading,
      snackbar,
      validate,
    };
  },
};
</script>

<style>
@import "../style.css";
</style>
